// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".btn svg.user-icon{height:30px;width:30px;background-color:#104182;color:white;padding:5px;border-radius:3px}\n", ""]);
// Exports
module.exports = exports;
